<template>
  <div>
    <div class="flex mb-5">
      <div class="w-6/12">
        <h1 class="text-xl font-bold text-gray-700">Users</h1>
      </div>
      <div class="w-6/12">
        <base-button-primary @click="newUser" class="float-right"
          >New User</base-button-primary
        >
      </div>
    </div>

    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="users"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <base-button-primary-extra-small @click="handleEdit(props.row)">
                Edit
              </base-button-primary-extra-small>

              <base-button-white-extra-small
                @click="handleDelete(props.row)"
                class="ml-3"
              >
                Remove
              </base-button-white-extra-small>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <user
      :show-modal="showModal"
      :user="user"
      :outfitter-id="outfitterId"
      @saved="save"
      @close="showModal = false"
    ></user>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import User from "@/components/common/User";
export default {
  name: "DashboardUsers",
  components: { VueGoodTable, User },
  data() {
    return {
      withDeleted: 0,
      showModal: false,
      user: {
        id: null,
        name: "",
        email: "",
        password: "",
        role: "",
        outfitter_id: null,
      },
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Role",
          field: "role",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    newUser() {
      this.user = {
        id: null,
        name: "",
        email: "",
        password: "",
        outfitter_id: this.$store.getters["auth/outfitterId"],
        role: "",
      };
      this.showModal = true;
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to remove this user?")) {
        this.$store
          .dispatch("user/delete_user", { id: row.id })
          .then((resp) => {
            if (!resp.success) return;

            this.$store.dispatch(
              "user/for_outfitter",
              this.$store.getters["auth/outfitterId"]
            );
          });
      }
    },

    save() {
      this.$store.dispatch(
        "user/for_outfitter",
        this.$store.getters["auth/outfitterId"]
      );
      this.$notify({
        title: "User",
        message: "Data Saved",
        type: "success",
      });
      this.showModal = false;
      this.user = {
        id: null,
        name: "",
        email: "",
        password: "",
        outfitter_id: null,
      };
    },
    handleEdit(row) {
      this.user = {
        id: row.id,
        name: row.name,
        role: row.role,
        email: row.email,
        outfitter_id: row.outfitter_id,
      };
      this.showModal = true;
    },
  },
  computed: {
    users: function () {
      return this.$store.getters["user/getUsers"];
    },
    outfitters: function () {
      return []; // this.$store.getters["outfitter/getOutfitters"];
    },
    outfitterId: function () {
      return this.$store.getters["auth/outfitterId"];
    },
  },
  mounted() {
    this.$store.dispatch("auth/set_outfitter_id", null).then((outfitter_id) => {
      this.$store.dispatch("user/for_outfitter", outfitter_id);
    });
    // console.log(this.$store.getters["auth/getUser"]);
    // this.$store.dispatch("user/all", { withDeleted: this.withDeleted });
    // this.$store.dispatch("outfitter/all", { withDeleted: 0 });
  },
};
</script>
